package org.mkui.component

import react.FC

actual interface CPComponentProvider : CPComponent {
    actual val component: CPComponent

    override val nativeComponent: FC<*>
        get() = component.nativeComponent
}